import * as actionTypes from './actionTypes';
//控制高鐵選單開關
export const setTHSROptsMOpen = (payload: any) => ({
    type: actionTypes.SET_THSROPTSMOPEN,
    payload,
});
//存放高鐵聯票初始資料
export const setTHSRInitData = (payload: any) => ({
    type: actionTypes.SET_THSRINITDATA,
    payload,
});
// 高鐵初始打的API若有問題的防呆action
export const setTHSRIsInitFail = (payload: boolean) => ({
    type: actionTypes.SET_THSRISINITFAIL,
    payload,
});
//高鐵聯票單日各站班次
export const setTHSRDetailData = (payload: any) => ({
    type: actionTypes.SET_THSRDETAILDATA,
    payload,
});

export const setTCurrentStep = (payload: any) => ({
    type: actionTypes.SET_TCURRENTSTEP,
    payload,
});
//高鐵車站靜態資源
export const setTHSRStations = (payload: any) => ({
    type: actionTypes.SET_THSRSTATIONS,
    payload,
});
//
export const setTHSRDetailLoading = (payload: any) => ({
    type: actionTypes.SET_THSRDETAILLOADING,
    payload,
});
//高鐵班次的搜尋條件
export const setTHSRSearchOption = (payload: any) => ({
    type: actionTypes.SET_THSRSEARCHOPTION,
    payload,
});
//目前高鐵開啟的面板（單程或來回）
export const setTHSROpenedPanel = (payload: any) => ({
    type: actionTypes.SET_THSROPENEDPANEL,
    payload,
});
//根據搜尋條件之規則資訊 API
export const setTHSRInfo = (payload) => ({
    type: actionTypes.SET_THSRInfo,
    payload,
});

export const setTHSRDepartTrain = (payload) => ({
    type: actionTypes.SET_THSRDEPARTTRAIN,
    payload,
});

export const setTHSRReturnTrain = (payload) => ({
    type: actionTypes.SET_THSRRETURNTRAIN,
    payload,
});

export const setTHSROtherTimeLoading = (payload) => ({
    type: actionTypes.SER_THSROTHERTIMELOADING,
    payload,
});

export const setTHSRHighestDiscounts = (payload) => ({
    type: actionTypes.SET_THSRHIGHESTDISCOUNTS,
    payload,
});

export const setTHSRTempTrainItems = (payload) => ({
    type: actionTypes.SET_THSRTEMPTRAINITEMS,
    payload,
});
